<template>
  <div class="rgsgame-game-backgroundimage" :style="{backgroundImage: 'url(' + gameimage + ')'}">
    <div class="rgsgame-game-details-container">
        <div class="flex-between">
            <h2>{{ gamename }}</h2>
            <img class="rgsgame-game-logo" :src="gamelogo"> 
        </div>
        <div class="game-description">
            <p>{{ gamedescription }}</p>  
        </div>
    </div>
  </div>
</template>

<script>
//   import store from '@/store'

  export default {
    name: 'igtRgsGameDetails',
    props: [
      'gameimage',
      'gamelogo',
      'gamename',
      'gamedescription'
    ],
    data () {
      return {}
    },
    computed: {},
    methods: {},
    mounted () {}
  }
</script>
<style scoped lang="stylus">
  @import '~@/css/config'
  @import '~@/css/mixins'

.rgsgame-game-backgroundimage
    position absolute
    top -10px
    left -10px 
    height calc(100% + 20px)
    overflow hidden
    overflow-y scroll
    width calc(100% + 100px)
    color var(--text-color)
    background #fff
    border-radius 5px
    -webkit-box-shadow 0px 0px 10px 5px rgba(0,0,0,0.2)
    -moz-box-shadow 0px 0px 10px 5px rgba(0,0,0,0.2)
    box-shadow 0px 0px 10px 5px rgba(0,0,0,0.2)
    cursor pointer
    background-position center
    background-repeat no-repeat
    background-size cover
    display flex
    color #fff
    @media mobile-big-and-below
        top -5px
        left -5px 
        height calc(100% + 10px)
        width calc(100% + 10px)
    &::-webkit-scrollbar
    display none
    &:before
        content ''
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        background rgb(0,0,0)
        background linear-gradient(180deg, rgba(0,0,0,0.70) 80%, rgba(0,0,0,0) 100%)
    .rgsgame-game-details-container
        position relative
        z-index 1
    .flex-between
        display flex
        flex-wrap wrap
        justify-content space-between
        align-items center
        padding 0 10px
        @media mobile-big-and-below
            flex-wrap nowrap
        h2 
            margin 0
            @media mobile-big-and-below
                font-size 14px
        .rgsgame-game-logo
            width 80px
            @media mobile-big-and-below
                width 65px
    .game-description
        position relative
        padding 0 15px 20px 10px
        text-shadow 3px 3px 4px rgba(0, 0, 0, 1)
        font-weight bold
        letter-spacing 1px
        font-size 11px
        @media mobile-big-and-below
            font-size 10px
            padding 10px
    
</style>


// WEBPACK FOOTER //
// src/components/gap/GameDetails.vue